// @flow

// A map from the name of each stat as used in the mod exporter to
// the name(s) of the property(ies) used internally by the mod optimizer
const statTypeMap = {
  Health: ["health"],
  Protection: ["protection"],
  Speed: ["speed"],
  "Critical Damage": ["critDmg"],
  Potency: ["potency"],
  Tenacity: ["tenacity"],
  Offense: ["physDmg", "specDmg"],
  "Physical Damage": ["physDmg"],
  "Special Damage": ["specDmg"],
  "Critical Chance": ["physCritChance", "specCritChance"],
  "Physical Critical Chance": ["physCritChance"],
  "Special Critical Chance": ["specCritChance"],
  Defense: ["armor", "resistance"],
  Armor: ["armor"],
  Resistance: ["resistance"],
  Accuracy: ["accuracy"],
  "Critical Avoidance": ["critAvoid"],
};

export const statIds = {
  "0": "None",
  "1": "Health",
  "2": "Strength",
  "3": "Agility",
  "4": "Tactics",
  "5": "Speed",
  "6": "Physical Damage",
  "7": "Special Damage",
  "8": "Armor",
  "9": "Resistance",
  "10": "Armor Penetration",
  "11": "Resistance Penetration",
  "12": "Dodge Chance",
  "13": "Deflection Chance",
  "14": "Physical Critical Chance",
  "15": "Special Critical Chance",
  "16": "Critical Damage %",
  "17": "Potency %",
  "18": "Tenacity %",
  "19": "Dodge",
  "20": "Deflection",
  "21": "Physical Critical Chance %",
  "22": "Special Critical Chance %",
  "23": "Armor %",
  "24": "Resistance %",
  "25": "Armor Penetration %",
  "26": "Resistance Penetration %",
  "27": "Health Steal",
  "28": "Protection",
  "29": "Protection Ignore",
  "30": "Health Regeneration",
  "31": "Physical Damage %",
  "32": "Special Damage %",
  "33": "Physical Accuracy",
  "34": "Special Accuracy",
  "35": "Physical Critical Avoidance",
  "36": "Special Critical Avoidance",
  "37": "Physical Accuracy %",
  "38": "Special Accuracy %",
  "39": "Physical Critical Avoidance %",
  "40": "Special Critical Avoidance %",
  "41": "Offense",
  "42": "Defense",
  "43": "Defense Penetration",
  "44": "Evasion",
  "45": "Critical Chance",
  "46": "Accuracy",
  "47": "Critical Avoidance",
  "48": "Offense %",
  "49": "Defense %",
  "50": "Defense Penetration %",
  "51": "Evasion %",
  "52": "Accuracy %",
  "53": "Critical Chance %",
  "54": "Critical Avoidance %",
  "55": "Health %",
  "56": "Protection %",
  "57": "Speed %",
  "58": "Counter Attack",
  "59": "UnitStat_Taunt",
  "61": "Mastery",
};

Object.freeze(statTypeMap);

export default statTypeMap;
